import {collection, getDoc, doc, getDocs, limit, orderBy, query, where, updateDoc, addDoc, setDoc, deleteDoc, increment as incr, deleteField, arrayUnion, arrayRemove, documentId, serverTimestamp, getCountFromServer, startAfter} from 'firebase/firestore'
import {firestore} from './firebase'
import now from 'lodash/now'
import reduce from 'lodash/reduce'
import flatten from 'lodash/flatten'
import isArray from 'lodash/isArray'
// import crypto from 'crypto'
export const colls = {
  'app-about': 'app-about',
  'ai-scribe': 'ai-scribe',
  'agent-config': 'agent-config',
  'ai-agents': 'ai-agents',
  'ai-agents-list': 'ai-agents-list',
  'ai-article': 'ai-article',
  'ai-augment': 'ai-augment',
  'ai-chat': 'ai-chat',
  'ai-chat-log': 'ai-chat-log',
  'ai-page-builder': 'ai-page-builder',
  'ai-workspace': 'ai-workspace',
  'amazon-lists': 'amazon-lists',
  'app-faq': 'app-faq',
  'art-image': 'art-image',
  'business-profile': 'business-profile',
  'openai-brainstorm': 'openai-brainstorm',
  'openai-content': 'openai-content',
  'openai-models': 'openai-models',
  'oven-apps': 'oven-apps',
  'oven-stripe-log': 'oven-stripe-log',
  'post': 'post',
  "stripe-customers": "stripe-customers",
  'stripe-products': 'stripe-products',
  'link-listings': 'link-listings',
  'looks': 'looks',
  'looks-swipe': 'looks-swipe',
  'stage': 'stage',
  'user': 'user',
  'user-audience': 'user-audience',
  'user-feedback': 'user-feedback',
  'user-interests': 'user-interests',
  'user-tips': 'user-tips',
  'wait-list': 'wait-list',
  'inbox': 'inbox',
  'outbox': 'outbox',
  'messages': 'messages',
  'prompts': 'prompts',
  'user-message': 'user-message',
  'ai-queue': 'ai-queue',
}
export const increment = incr
export const ServerTimestamp = serverTimestamp

/**
 * @param {[]} querySnapshot
 */
export const toDataPairs = (querySnapshot) => {
  if (!querySnapshot?.size) return []
  const pairs = []
  querySnapshot.size && querySnapshot.docs.forEach(snapshot => pairs.push([snapshot.id, snapshot.data()]))
  return pairs
}
export const generateID = () => doc(collection(firestore, 'dummy')).id

/**
 * @param rawJson {object} - raw json object
 * @returns {{length}|*|null|{}|null} - json object with all null values removed
 */
export const safeValueForDB = (rawJson) => {
  switch (true) {
    case (rawJson == null): {
      return {};
    }
    case isArray(rawJson): {
      const array = rawJson.reduce((accumulator, item) => {
        if (item && item !== undefined) accumulator.push(safeValueForDB(item));
        return accumulator;
      }, []);
      return array.length ? array : null;
    }
    case (typeof rawJson === "object"): {
      if (rawJson.constructor.name === "Timestamp") {
        return rawJson;
      }
      const map = {};
      Object.keys(rawJson).forEach((key) => {
        if (key && rawJson[key] !== undefined && rawJson[key] != null) {
          map[key] = safeValueForDB(rawJson[key]);
        }
      });
      return map;
    }
    default: {
      if (rawJson === undefined) rawJson = null;
      return rawJson;
    }
  }
}
/**
 * @summary Sanitize string for use as db key
 * @static
 * @param {string} key
 * @param {Number} maxLength
 * @return {string}
 */
export const safeKeyForDB = (key, maxLength = 250) => {
  // Remove any special characters and limit the string length
  const sanitizedUrl = key.replace(/[^\w\d]/g, "_").substring(0, maxLength);
  /**
   * TODO - Implement browser safe crypto module and uncomment below
   *    until fixed, urls greater maxLength param will not be retrieved.
   */
  // If the sanitized URL is too long, create a hash to ensure uniqueness
  // if (sanitizedUrl.length === maxLength) {
  //   const hash = crypto.createHash("md5").update(key).digest("hex");
  //   return sanitizedUrl.substring(0, maxLength - hash.length) + hash;
  // }
  return sanitizedUrl;
};
/**
 *
 * @param collectionPath {string|string[]} - name of the collection
 * @param fields {object} - fields to query by (e.g. {name: 'John'})
 * @param queryLimit {number} - limit the number of results
 * @param order {[]} - order by (e.g. [['name', 'asc']])
 * @param {{startAfter: Number|String}} [pagingOptions] - paging options (e.g. {startAfter: 'abc123'})
 * @returns {Query<DocumentData>} - firestore query object
 */
export const buildQuery = (collectionPath, fields, {limit: queryLimit = 10, order = []} = {}, pagingOptions) => {
  const collectionName = typeof collectionPath === 'string' ? collectionPath : collectionPath.join('/')
  const queryFields = [...flatten(Object.keys(fields).map(indicator => {
    return reduce(fields[indicator], (predicates, value, fieldName) => {
      predicates.push(where(fieldName, indicator, value))
      return predicates
    }, [])
  })),
    ...order.map(([field, direction = 'asc']) => orderBy(field, direction)),
    limit(queryLimit),
  ];
  pagingOptions?.startAfter && queryFields.push(startAfter(pagingOptions.startAfter))
  return query(
    collection(firestore, collectionName),
    ...queryFields)
}
/**
 * @summary Get a count of query results from the server
 * @param {FirebaseFirestore.Query} query
 * @return {Promise<number>}
 */
export const getCollectionCount = async (query) => {
  const snap = await getCountFromServer(query);
  return snap.data().count;
}
/**
 * @param {string} collectionPath - name of the collection
 * @param documentId {string} - document id to get from collection
 */
export const getDocumentRef = (collectionPath, documentId) => {
  // if (!documentId) throw new Error(`documentID is required`)
  // if (Object.values(colls).indexOf(collectionName) === -1) throw new Error(`"${collectionName}" not found in colls map`)
  return doc(firestore, `${collectionPath}/${documentId}`)
}
export const getDocuments = query => getDocs(query)
/**
 * @summary get a collection reference
 * @param {string | string[]} collectionNameOrPath
 * @return {CollectionReference<DocumentData>}
 */
export const getCollection = collectionNameOrPath => {
  if (!collectionNameOrPath) throw new Error(`CollectionName is required`)
  const collectionPath = (isArray(collectionNameOrPath)) ? collectionNameOrPath.join('/') : collectionNameOrPath
  if (Object.values(colls).indexOf(collectionPath.split('/')[0]) < 0) throw new Error(`"${collectionPath}" not found in colls map`)
  return collection(firestore, collectionPath)
}
/**
 * @summary get a document reference
 * @param {string | string[]} collectionPath
 * @param {string} documentId
 * @return {Promise<DocumentSnapshot<DocumentData>>}
 */
export const getDocument = async (collectionPath, documentId) => {
  if (!documentId) throw new Error(`documentID is required`);
  // convert collectionPath to string if it's an array
  const collectionName = (isArray(collectionPath)) ? collectionPath.join('/') : collectionPath;
  return await getDoc(getDocumentRef(collectionName, documentId));
}
export const updateDocument = async (collectionName, documentId, data) => {
  const ref = getDocumentRef(collectionName, documentId)
  return !!ref && await updateDoc(ref, data)
}
export const addDocument = async (collectionName, data) => {
  const collection = getCollection(collectionName)
  return !!data && !!collection && await addDoc(collection, {
    ...data, createdTs: now(), updatedTs: now(),
  })
}
export const addDocumentSub = async (pathArray, data) => {
  const collection = getCollection(pathArray)
  return !!data && !!collection && await addDoc(collection, {
    ...safeValueForDB(data), created: ServerTimestamp(), updated: ServerTimestamp(),
  })
}
export const addDocument_NoTimestamp = async (collectionName, data) => {
  const collection = getCollection(collectionName)
  return !!data && !!collection && await addDoc(collection, data)
}
export const setDocument = async (collectionName, documentId, data, merge = false) => {
  const ref = getDocumentRef(collectionName, documentId)
  if (!ref) return false
  return merge ?
    await setDoc(ref, data, {merge: true}) :
    await setDoc(ref, data)
}
export const setDocumentSub = async (collectionPath, documentId, data, merge = false) => {
  const ref = doc(firestore, collectionPath.join('/'), documentId)
  if (!ref) return false
  return merge ?
    await setDoc(ref, data, {merge: true}) :
    await setDoc(ref, data)
}
export const deleteDocument = async (collectionName, documentId) => {
  const ref = getDocumentRef(collectionName, documentId)
  return !!ref && await deleteDoc(ref)
}
export const Fields = {
  deleteField,
  arrayUnion,
  arrayRemove,
  documentId,
}
